import React, { useEffect } from 'react';

import { Container, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import CreatorList from './CreatorList';
import InviteCreator from './InviteCreator';
import { ACTIONS } from '../../constants/logs';
import LogService from '../../services/log.service';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
  },
  creatorTable: {
    paddingRight: theme.spacing(6),
  },
  subtitle1: {
    fontSize: 12,
    paddingTop: theme.spacing(2),
  },
}));

export default () => {
  const classes = useStyles();

  useEffect(() => {
    new LogService().create({
      action: ACTIONS.CREATORS_VIEWED,
      details: {
        Amount: 10,
        Page: 1,
      },
    });
  }, []);

  return (
    <Container component="main" className={classes.container}>
      <Container component="div" xs={8} disableGutters style={{ paddingLeft: '8px' }}>
        <Typography variant="h4" align="left" className="page-header">
          Creators
        </Typography>
        <Typography variant="subtitle1" align="left" className={`body-copy ${classes.subtitle1}`}>
          View a list of current creators or invite new <br /> creators to your workspace
        </Typography>
      </Container>
      <Grid container className={classes.container}>
        <Grid item xs={12} sm={6} className={classes.creatorTable}>
          <CreatorList />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InviteCreator />
        </Grid>
      </Grid>
    </Container>
  );
};
